export default __webpack_public_path__ + "static/media/pixels-project-1.f63747a1.jpg";